// Ajitesh : 16/02/2024: BT-109380 Contact Us - Start
import { getBranchesForContactUs } from "../../apis/nontransactional"
import { HELP } from "../actionTypes";

export const getBranchDetails =  () => async (dispatch) => {
    dispatch(updateIsLoadingBranchesInfo(true));
    const objResponse = await getBranchesForContactUs();
    if(objResponse.status) {
        dispatch(updateIsLoadingBranchesInfo(false));
        dispatch(getBranchDetailsSuccess(objResponse?.data?.result))
    }
    else {
        dispatch(updateIsLoadingBranchesInfo(false));
        dispatch(getBranchDetailsFailure([]))
    }
}

export const updateIsLoadingBranchesInfo = (payload) => {
    return { type: HELP.UPDATE_IS_LOADING_BRANCHES_INFO, payload }
}

export const getBranchDetailsSuccess = (payload) => {
    return { type: HELP.GET_BRANCH_DETAILS_SUCCESS, payload }
}

export const getBranchDetailsFailure = (payload) => {
    return { type: HELP.GET_BRANCH_DETAILS_FAILURE, payload }
}
// Ajitesh : 16/02/2024: BT-109380 Contact Us - End